module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAABZ0lEQVQ4T6XTTavNURQH4OfnZYC6SknkZaoUmYgZA+UlE1NFSr4BI6UYKZ/A5FJMTbyklIGBYqCUZChcRZFCd0CW9nHO7fg76X+uPdx77ae19l4rJqyqWofT2I/1eIf7uJLkQ/dKuhtVdRDXsWaC/wnHktwbP/sDqarteIRVkzIc7n3D7iTPRzFd5A4O/QMYHd1OcuQvpKpm8BHLeiA/WrlJvrTYhUyqas+wlB7GIKSV9LiLnMWlvgLOJLncReawYQrkbZJNC0hVtbK+YuUUSIufSTK4rKou4twUwCj0QpLzGfbGUyxdBNJ+aWdDruLEIoDRldmGtFlY+x/I+4a0ebiFfRi8ds/1Gg9xoCFt4B7geJvSnkALO4Ub2DvesVvwDKt7QJ+xI0nL5nfbV1Xrj5eLKGdrkvkR0t7iFZZ0sviOmziK5Z2zn9icZG68nMM4iY2YxxNcS/KiqrYN32wXVuANZpPcbfAvi3d06jbxogMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/qq.png
// module id = s+8k
// module chunks = 0